// Constructors can run on empty elements (including shallow DOM clones).
// Wait for required children on connection, and stop observing on removal.
function initializeElementWhenReady(element, initialize) {
  element.initializationObserver?.disconnect();
  if (!element.isConnected || initialize() !== false) return;
  element.initializationObserver = new MutationObserver(() => {
    if (element.isConnected && initialize() !== false) element.initializationObserver.disconnect();
  });
  element.initializationObserver.observe(element, { childList: true, subtree: true });
}

function rafThrottle(callback) {
  let requestId = null;
  return (...args) => {
    if (requestId !== null) return;
    requestId = window.requestAnimationFrame(() => {
      requestId = null;
      callback(...args);
    });
  };
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}
